import type {IRates} from '@/types/Rate';

export function convertCurrency({
  from,
  to,
  value,
  rates,
}: {
  from: string;
  to: string;
  value: number;
  rates: IRates;
}) {
  const exchangeRate = getExchangeRate(from, to, rates);
  return value * Number(exchangeRate);
}

// The `from` amount that swaps into `value` of `to`: divided by the from to to
// cell, the way the swap itself prices it, and never the to to from cell.
export function convertToSourceCurrency({
  from,
  to,
  value,
  rates,
}: {
  from: string;
  to: string;
  value: number;
  rates: IRates;
}) {
  return value / Number(getExchangeRate(from, to, rates));
}

export function getExchangeRate(from: string, to: string, rates: IRates) {
  return rates[from][to];
}
